const CompetitionList = require('ffss/component/row/competition/List');

class CompetitionSearch{
    defaultOptions() {
        return {
        	'$container': null,
        	'urlDetail': '/competition/detail'
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmit = this.onSubmit.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.onClickNext = this.onClickNext.bind(this);

        this.$container = this.settings.$container;
        if(!this.$container){
        	window.notify("$container is missing in component/row/CompetitionSearch","error");
        }

        this.$listContainer = $('.competition-search-list',this.$container);
        this.$noResultContainer = $('.competition-search-noresult',this.$container);

        this.$form = $('.competition-search-form',this.$container);
        this.$resultContainer = $('.competition-search-result-container',this.$container);
        this.$loader = $('.competition-search-loader',this.$container);

        this.$filterSaison = $('select[name="saison"]',this.$form);
        this.$filterSpecialite = $('select[name="specialite"]',this.$form);
        this.$filterNiveau = $('select[name="niveau"]',this.$form);
        this.$filterSearch = $('input[name="search"]',this.$form);
        this.$filterVisibility = $('select[name="visibility"]',this.$form);

        this.currentOffset = 0;
        this.currentRequest =  null;

        this.initialize();
    }


    initialize(){
    	var self = this;

    	this.$form.on('submit',this.onSubmit);
		this.$filterSaison.on('change',this.onFilterChange);
		this.$filterSpecialite.on('change',this.onFilterChange);
		this.$filterNiveau.on('change',this.onFilterChange);
		this.$filterSearch.on('change',this.onFilterChange);
        this.$filterVisibility.on('change',this.onFilterChange);

		
		this.list = new CompetitionList({
			'$container': this.$listContainer,
			'onClickNext': this.onClickNext,
			'urlDetail': this.settings.urlDetail
		});

		if(this.$filterSaison.val()){
			setTimeout(function(){
				self.$filterSaison.trigger('change');
			}, 300)
		}
    }

    onFilterChange(event){
    	let $filter = $(event.target);

    	let filterName = $filter.attr('name');


        let saison = this.$filterSaison.val();
        let visibility = this.$filterVisibility.val();

        let $selectedSaison = $('option:selected',this.$filterSaison);
        if($selectedSaison.data('current')){
            this.$filterVisibility.prop('disabled',false);

            if(filterName == 'saison'){
                this.$filterVisibility
                .val("incoming")
                .trigger('change.select2')
            }
        }else{
            let visibility = "passed";
            if($selectedSaison.data('visibility')){
                visibility = $selectedSaison.data('visibility');
            }
            this.$filterVisibility
            .val(visibility)
            .prop('disabled',true)
            .trigger('change.select2');
        }

    	this.currentOffset = 0;

    	if(this.canSubmit()){
    		this.$form.trigger('submit');
    	}
    }

    canSubmit(){
    	let saison = this.$filterSaison.val();
    	let specialite = this.$filterSpecialite.val();
    	let niveau = this.$filterNiveau.val();
    	let search = this.$filterSearch.val();
        let visibility = this.$filterVisibility.val();


    	if(!saison){
    		return false;
    	}

    	return true;
    }

    onSubmit(event){
		event.preventDefault();
		event.stopPropagation();

		this.doSubmit(true);

    }

    getData(){
    	let data = this.$form.serializeArray();

    	data.push({
    		'name': 'start',
    		'value': this.currentOffset
    	});
    	return data;
    }

    doSubmit(clearList){
    	var self = this;

        
        if(this.currentRequest != null){
            this.currentRequest.abort();
        }

		this.$resultContainer.show();
		this.$loader.show();
		this.$noResultContainer.hide();

		if(clearList){
			this.$listContainer.hide();
		}

		this.list.setNeedClear(clearList);

    	let data = this.getData();

        this.currentRequest = $.ajax({
    		'url': this.$form.attr('action'),
    		'method': this.$form.attr('method'),
    		'data': data
    	})
    	.done(function(xhr){
    		if(xhr.success){
    			let data = xhr.data;
    			self.showResult(xhr);
    		}else{
    			window.notify("todo notification of error : "+ xhr.message,"error");
    		}
    	})
    	.fail(function(){
    		window.notify("todo notification of error","error");
    	})
    	.always(function(){
    		self.$loader.hide();
    	});

    }

    showResult(xhr){
    	if(xhr.data.length == 0){
    		this.$noResultContainer.show();
    	}else{
    		this.fillListWithResult(xhr);
    		this.$listContainer.show();
	    }
    }

	fillListWithResult(data){
		this.list.setData(data);
	}

	onClickNext(offset){
		this.currentOffset = offset;

		this.doSubmit(false);
	}

}

module.exports = CompetitionSearch;